import React from "react"
import Container from "./IconContainer"

const LocationIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="16px"
      height="18px"
      viewBox="0 0 16 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 15 Copy 3</title>
      <desc>Created with Sketch.</desc>
      <g
        id="190716-V2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="190723_NYT-dashboard-unauth"
          transform="translate(-107.000000, -1485.000000)"
          stroke="#505050"
        >
          <g
            id="Group-15-Copy-3"
            transform="translate(108.000000, 1485.000000)"
          >
            <g
              id="smartphone"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            >
              <rect
                id="Rectangle-path"
                x="0"
                y="0.846153846"
                width="10"
                height="16"
              />
            </g>
            <rect
              id="Rectangle-path"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              x="2.88461538"
              y="12.0384615"
              width="4.03846154"
              height="4.61538462"
            />
            <path
              d="M2.59615385,8.07692308 L7.21153846,8.07692308"
              id="Line-4"
              strokeWidth="1.25"
              strokeLinecap="round"
            />
            <path
              d="M2.59615385,6 L7.21153846,6"
              id="Line-4-Copy-2"
              strokeWidth="1.25"
              strokeLinecap="round"
            />
            <path
              d="M2.59615385,4 L7.21153846,4"
              id="Line-4-Copy-3"
              strokeWidth="1.25"
              strokeLinecap="round"
            />
            <rect
              id="Rectangle"
              strokeWidth="1.5"
              strokeLinejoin="round"
              x="10.0961538"
              y="8.75"
              width="4"
              height="8.07692308"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default LocationIcon



// WEBPACK FOOTER //
// ./assets/common/components/icons/LocationIcon.js